import { useBoolean } from "ahooks";
import { Button, Input, Tag } from "antd";
import { ColumnsType } from "antd/lib/table";
import React, { useContext, useEffect, useState } from "react";
import { ButtonPanel } from "../../../../component/button-panel/button_panel";
import { Search } from "../../../../component/search";
import { DataTable } from "../../../../component/table";
import { DataTableStore } from "../../../../component/table/store/data_table_store";
import { Form } from "./coupon_from";
import { seckillAction } from "../../action/coupon/file_action";
import { CouponStore } from "../../store/coupon/file_store";
import { CouponFormStoreProvider } from "../../store/coupon/form_store";
import { TableExpand } from "../../../../component/table-expand";
import { ConfirmModal } from "../../../../component/modal";
import { Tips, TipsGroup } from "../../../../component/tips";
import { InventorySearch } from "./file_search";
import { Mask } from "../../../../component/mask";
import { defualtPageSize, Progress } from "../../../../logic/common_logic";
import { AuthLogic } from "../../../../logic/auth_logic";
import { Control, Del, Edit, See } from "../../../../component/control-column";
import { render } from "@testing-library/react";
import img_stop from "../../../../assets/images/zz.png";
const formParams = {
  method: "Create",
  id: "",
  subId: "",
  item: null,
};

export function Coupon(viewPower) {
  const [createState, createFunc] = useBoolean(false);
  const [searchState, searchFunc] = useBoolean(false);
  const [confirmState, confirmFunc] = useBoolean(false);
  const [statusState, statusFunc] = useBoolean(false);
  const { state, dispatch } = useContext(CouponStore);
  const { state: tableState, dispatch: tableDispatch } =
    useContext(DataTableStore);
  const [] = useBoolean(false);

  const action = seckillAction,
    formAction = seckillAction;

  const [menuButton, setData] = useState([]);
  useEffect(() => {
    (async function () {
      let r = await new AuthLogic().selButton(viewPower.viewPower);
      if (r && r.length > 0) {
        for (let i = 0; i < r.length; i++) {
          r[i] = r[i].split("_")[r[i].split("_").length - 1];
        }
      }
      setData(r);
    })();

    return () => {};
  }, []);
  const columns: ColumnsType = [
    {
      title: "操作",
      key: "1",
      dataIndex: "oddNumbers",
      align: "center",
      width: Control.width(4),
      render: Control.render(
        (v, r) =>
          menuButton.indexOf("VIEW") != -1 && (
            <See
              click={() => {
                formParams.id = r.id;
                formParams.method = "Preview";

                createFunc.setTrue();
              }}
            />
          ),
        (v, r) =>
          menuButton.indexOf("UPDATE") != -1 && (
            <Edit
              click={() => {
                formParams.id = r.id;
                formParams.subId = r.id;
                formParams.method = "Edit";
                formParams.item = r;

                createFunc.setTrue();
              }}
            />
          ),
        (v, r) =>
          menuButton.indexOf("DELETE") != -1 && (
            <Del
              click={() => {
                formParams.id = r.id;
                formParams.subId = r.id;

                confirmFunc.setTrue();
              }}
            />
          ),
        (v, r) =>
          menuButton.indexOf("STOP") != -1 &&
          r.status == 1 && (
            <img
              src={img_stop}
              alt=""
              onClick={() => {
                formParams.id = r.id;
                formParams.subId = r.id;
                statusFunc.setTrue();
              }}
            />
          )
      ),
    },
    {
      title: "优惠券名称",
      dataIndex: "couponName",
      key: "3",
      align: "center",
    },
    {
      title: "类型",
      dataIndex: "couponType",
      key: "4",
      align: "center",
      render: (v) => (
        <>
          {v == 2 && <Tag color="success">直减券</Tag>}
          {v == 1 && <Tag color="error">折扣券</Tag>}
        </>
      ),
    },
    {
      title: "面额/折扣",
      key: "5",
      align: "center",
      render: (v) => (
        <span>
          {v.couponType == 2 ? v.subMoney + "元" : v.discount / 10 + "折"}
        </span>
      ),
    },
    {
      title: "使用条件",
      key: "6",
      align: "center",
      render: (v) => <span>满{v.meetMoney}元可用</span>,
    },
    {
      title: "领券方式",
      dataIndex: "getCouponType",
      key: "7",
      align: "center",
      render: (v) => (
        <>
          {v == 1 && <Tag color="success">主动领取</Tag>}
          {v == 2 && <Tag color="error">系统发放</Tag>}
          {v == 3 && <Tag color="geekblue">积分兑换</Tag>}
        </>
      ),
    },
    {
      title: "数量",
      dataIndex: "couponNumber",
      key: "8",
      align: "center",
    },
    {
      title: "领取数量",
      dataIndex: "getCouponCount",
      key: "8",
      align: "center",
    },
    {
      title: "使用数量",
      dataIndex: "useCouponCount",
      key: "8",
      align: "center",
    },
    {
      title: "有效期",
      key: "8",
      align: "center",
      width: 160,
      render: (v) => (
        <>
          {v.validType == 1 ? (
            <span>
              {v.validStartDate}~{v.validEndDate}
            </span>
          ) : (
            <span>领取后{v.validDay}天有效</span>
          )}
        </>
      ),
    },
    {
      title: "状态",
      dataIndex: "status",
      key: "8",
      align: "center",
      render: (v) => (
        <>
          {v == 1 && <Tag color="success">启用</Tag>}
          {v == 2 && <Tag color="error">禁用</Tag>}
        </>
      ),
    },
  ];

  const onSearch = async (pageIndex) => {
    searchFunc.setFalse();
    await action.loadPage({
      pageIndex: pageIndex,
      pageSize: defualtPageSize(),
      dispatch: tableDispatch,
      search: state.search,
    });
  };
  const totalNumber = () => {
    let total = 0;
    tableState.dataList.forEach((v) => {
      total += v.number;
    });
    return total;
  };
  const totalPrice = () => {
    let total = 0;
    tableState.dataList.forEach((v) => {
      total += v.money;
    });
    return total;
  };

  return (
    <>
      <Search>
        <Input
          allowClear
          placeholder="请输入优惠券名称"
          maxLength={20}
          onChange={(e) =>
            action.setCondition({
              dispatch,
              key: "couponName",
              value: e.target.value,
            })
          }
        />
        <input type="button" value="快速查找" onClick={() => onSearch(1)} />

        <TipsGroup>
          <input
            type="button"
            value="高级查找"
            onClick={() => searchFunc.toggle()}
          />
          <Tips display={searchState} width="48rem">
            <InventorySearch onSearch={() => onSearch(1)} />
          </Tips>
          <Mask visible={searchState} onClick={() => searchFunc.setFalse()} />
        </TipsGroup>
      </Search>

      <ButtonPanel>
        {menuButton.indexOf("ADD") != -1 && (
          <Button
            onClick={() => {
              formParams.id = "";
              formParams.method = "Create";

              createFunc.setTrue();
            }}
          >
            新增优惠券
          </Button>
        )}
      </ButtonPanel>

      <DataTable
        columns={columns}
        action={action}
        onLoad={async () => {
          await onSearch(1);
          Progress.done();
        }}
        onChange={(pageIndex) => {
          onSearch(pageIndex);
        }}
        scroll={{ scrollToFirstRowOnChange: true, autoY: true, x: 1060 }}
        loading={tableState.loading}
      />

      {createState && (
        <CouponFormStoreProvider>
          <Form
            audit={true}
            close={(hasUpdate) => {
              if (hasUpdate) {
                onSearch(tableState.current);
              }

              createFunc.setFalse();
            }}
            action={formAction}
            id={formParams.id}
            subId={formParams.subId}
            item={formParams.item}
            method={formParams.method}
          />
        </CouponFormStoreProvider>
      )}

      <ConfirmModal
        visible={confirmState}
        title="温馨提示"
        subTitle="确认删除？"
        message="删除之后信息无法恢复，请慎重考虑"
        close={async (r) => {
          if (r) {
            await action.delRow(formParams.subId);

            onSearch(tableState.current);
          }
          confirmFunc.setFalse();
        }}
      />
      <ConfirmModal
        visible={statusState}
        title="温馨提示"
        subTitle="确认禁用？"
        message="禁用之后状态无法恢复，请慎重考虑"
        close={async (r) => {
          if (r) {
            await action.changeStatus({ id: formParams.subId });

            onSearch(tableState.current);
          }
          statusFunc.setFalse();
        }}
      />
    </>
  );
}
